/**
 * S3 operations via backend API (presigned URLs, delete).
 * Use for Project Page Component media upload flow.
 */
import { api } from "./api";

function unwrap(res) {
  if (res && (res.error || res.success === false)) {
    throw new Error(res.error || res.message || "Request failed");
  }
  return res?.data ?? res;
}

export async function getPresignedUploadUrl({ key, contentType, expiresIn }) {
  const body = { key };
  if (contentType) body.contentType = contentType;
  if (expiresIn) body.expiresIn = expiresIn;
  const res = await api.post("/api/s3/presigned-upload-url", body);
  return unwrap(res);
}

export async function deleteS3Object(key) {
  const res = await api.post("/api/s3/delete", { key });
  return unwrap(res);
}

/**
 * Upload a file to S3 using a presigned URL (PUT).
 * @param {string} url - Presigned PUT URL from getPresignedUploadUrl
 * @param {File} file - File to upload
 * @returns {Promise<void>}
 */
export async function uploadFileToPresignedUrl(url, file) {
  const response = await fetch(url, {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": file.type || "application/octet-stream",
    },
  });
  if (!response.ok) {
    throw new Error(`Upload failed: ${response.status} ${response.statusText}`);
  }
}
